<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M5.05322 0.724998H6.94681V2.61859H5.05322V0.724998ZM5.05322 3.8359H6.94681V11.275H5.05322V3.8359Z"
    fill="#150E0B"
  />
</svg>
